import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const LinkedInCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const hasRun = useRef(false);

  useEffect(() => {
    // Prevent double execution
    if (hasRun.current) {
      //console.log("Already executed, skipping");
      return;
    }
    hasRun.current = true;

    const code = searchParams.get("code");
    const urlState = searchParams.get("state");
    const error = searchParams.get("error");

    //console.log("=== LinkedIn Callback Debug ===");
    //console.log("1. Code from URL:", code);
    //console.log("2. State from URL:", urlState);
    //console.log("3. Error from URL:", error);
    //console.log("4. window.opener exists:", !!window.opener);

    if (error) {
      console.error("LinkedIn returned error:", error);
      if (window.opener) {
        window.opener.postMessage(
          { type: "linkedin-auth-error", error },
          window.location.origin,
        );
        window.close();
      } else {
        navigate("/login?error=" + error);
      }
      return;
    }

    if (!code) {
      console.error("No code received from LinkedIn");
      if (window.opener) {
        window.opener.postMessage(
          { type: "linkedin-auth-error", error: "No code received" },
          window.location.origin,
        );
        window.close();
      } else {
        navigate("/login?error=no_code");
      }
      return;
    }

    if (!urlState) {
      console.error("No state received from LinkedIn");
      if (window.opener) {
        window.opener.postMessage(
          { type: "linkedin-auth-error", error: "No state in URL" },
          window.location.origin,
        );
        window.close();
      } else {
        navigate("/login?error=no_state");
      }
      return;
    }

    // Get stored state
    const storedState = localStorage.getItem("linkedin_oauth_state");
    //console.log("5. Stored state from localStorage:", storedState);

    if (!storedState) {
      console.error("No stored state in localStorage!");
      //console.log("All localStorage keys:", Object.keys(localStorage));
      if (window.opener) {
        window.opener.postMessage(
          { type: "linkedin-auth-error", error: "No stored state" },
          window.location.origin,
        );
        window.close();
      } else {
        navigate("/login?error=no_stored_state");
      }
      return;
    }

    // Compare states

    if (urlState === storedState) {
      // Clean up stored state
      localStorage.removeItem("linkedin_oauth_state");

      // Send code to parent window
      if (window.opener) {
        window.opener.postMessage(
          { type: "linkedin-auth", code },
          window.location.origin,
        );

        setTimeout(() => {
          window.close();
        }, 2000);
      } else {
        //console.log(
        //  "7. No opener - storing code in sessionStorage and redirecting",
        //);
        sessionStorage.setItem("linkedin_auth_code", code);
        navigate("/login");
      }
    } else {
      console.error("❌ State verification FAILED");
      //console.log("URL state length:", urlState.length);
      //console.log("Stored state length:", storedState.length);
      //console.log(
      //   "URL state bytes:",
      //   urlState.split("").map((c) => c.charCodeAt(0)),
      // );
      // console.log(
      //   "Stored state bytes:",
      //   storedState.split("").map((c) => c.charCodeAt(0)),
      // );

      if (window.opener) {
        window.opener.postMessage(
          { type: "linkedin-auth-error", error: "State does not match" },
          window.location.origin,
        );
        window.close();
      } else {
        navigate("/login?error=state_mismatch");
      }
    }
  }, [searchParams, navigate]);

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h2>Processing LinkedIn login...</h2>
      <p>Please wait while we complete your authentication.</p>
      <p style={{ fontSize: "0.875rem", color: "#666", marginTop: "1rem" }}>
        ⏰ Popup will stay open for 10 seconds for debugging
      </p>
      <p style={{ fontSize: "0.875rem", color: "#666" }}>
        Open browser console (F12) to see debug logs
      </p>
    </div>
  );
};

export default LinkedInCallback;
